/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Home from './Home/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
let Appointments = React.lazy(() => import('./Appointments/index'))
let Comms = React.lazy(() => import('./Comms/index'))
let Financial = React.lazy(() => import('./Financial/index'))
let Profile = React.lazy(() => import('./Profile/index'))
let Requests = React.lazy(() => import('./Requests/index'))



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Home'
  return (<React.Fragment
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'Home'}>
<Home
{...childProps}
  viewPath={`${viewPath}/Home`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Appointments'}>
<Appointments
{...childProps}
  viewPath={`${viewPath}/Appointments`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Comms'}>
<Comms
{...childProps}
  viewPath={`${viewPath}/Comms`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Profile'}>
<Profile
{...childProps}
  viewPath={`${viewPath}/Profile`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Financial'}>
<Financial
{...childProps}
  viewPath={`${viewPath}/Financial`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Requests'}>
<Requests
{...childProps}
  viewPath={`${viewPath}/Requests`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
{children}
</React.Fragment>)
}